import type { Theme, FontPairing } from "@structurify/shared-types";

export const THEMES = {
  document: {
    bg: "#efebe2",
    surface: "#f7f4ed",
    panel: "#fbf9f3",
    ink: "#1a1814",
    inkSoft: "#46413a",
    inkMute: "#857d6f",
    rule: "rgba(26,24,20,0.12)",
    ruleStrong: "rgba(26,24,20,0.32)",
    docPaper: "#fdfbf4",
    docSubtle: "#7a7264",
    accent: "#b88a2c",
    accentSoft: "rgba(184,138,44,0.18)",
    confidenceLow: "#a85a3c",
    chipBg: "rgba(26,24,20,0.04)",
    chipBorder: "rgba(26,24,20,0.10)",
    canvas: "radial-gradient(ellipse 1400px 700px at 50% -200px, #f3eee2 0%, #efebe2 50%, #ebe6da 100%)",
  } satisfies Theme,

  invisible: {
    bg: "#fafaf9",
    surface: "#ffffff",
    panel: "#ffffff",
    ink: "#0a0a09",
    inkSoft: "#3a3a38",
    inkMute: "#8a8a86",
    rule: "rgba(10,10,9,0.08)",
    ruleStrong: "rgba(10,10,9,0.22)",
    docPaper: "#ffffff",
    docSubtle: "#7a7a76",
    accent: "#9a7a2a",
    accentSoft: "rgba(154,122,42,0.14)",
    confidenceLow: "#a35030",
    chipBg: "rgba(10,10,9,0.035)",
    chipBorder: "rgba(10,10,9,0.08)",
    canvas: "#fafaf9",
  } satisfies Theme,

  calm: {
    bg: "#f4f1ea",
    surface: "#ffffff",
    panel: "#ffffff",
    ink: "#15140f",
    inkSoft: "#3d3a31",
    inkMute: "#7d7669",
    rule: "rgba(21,20,15,0.10)",
    ruleStrong: "rgba(21,20,15,0.28)",
    docPaper: "#fefcf6",
    docSubtle: "#80786a",
    accent: "#7a5a1c",
    accentSoft: "rgba(122,90,28,0.14)",
    confidenceLow: "#8c4a2c",
    chipBg: "rgba(21,20,15,0.035)",
    chipBorder: "rgba(21,20,15,0.10)",
    canvas: "linear-gradient(180deg, #f4f1ea 0%, #ece8de 100%)",
  } satisfies Theme,
} as const;

export const FONT_PAIRINGS = {
  editorial: {
    serif: '"Fraunces", "Source Serif Pro", ui-serif, Georgia, serif',
    sans: '"Inter Tight", "Inter", system-ui, sans-serif',
    mono: '"JetBrains Mono", "IBM Plex Mono", ui-monospace, monospace',
    headerFamily: "serif" as const,
    headerWeight: 380,
    headerTracking: "-0.02em",
  } satisfies FontPairing,

  swiss: {
    serif: '"Inter Tight", "Inter", system-ui, sans-serif',
    sans: '"Inter Tight", "Inter", system-ui, sans-serif',
    mono: '"JetBrains Mono", ui-monospace, monospace',
    headerFamily: "sans" as const,
    headerWeight: 500,
    headerTracking: "-0.03em",
  } satisfies FontPairing,

  modern: {
    serif: '"Instrument Serif", "Source Serif Pro", ui-serif, Georgia, serif',
    sans: '"Inter", system-ui, sans-serif',
    mono: '"JetBrains Mono", ui-monospace, monospace',
    headerFamily: "serif" as const,
    headerWeight: 400,
    headerTracking: "-0.015em",
  } satisfies FontPairing,
} as const;

// Locked aesthetic — Invisible Utility + Swiss
export const THEME = THEMES.invisible;
export const FONTS = FONT_PAIRINGS.swiss;
